import { isString } from 'util';
import { KeyValueObject } from '../../../../../shared/models/key-value-object';


export const DISTANCE_TYPES: Array<string> = [
	'any',
	'/ST03-D50M',
	'/ST03-D100M',
	'/ST03-D200M',
	'/ST03-D300M',
	'/ST03-D500M',
	'/ST03-D1KM',
	'/ST03-D2KM',
	'/ST03-D5KM',
	'/ST03-D10KM',
	'/ST03-D20KM',
	'/ST03-D50KM',
	'/ST03-D100KM',
];

export const DISTANCE_TRANSLATIONS: KeyValueObject<string> = {
	'any': 'beliebig',
	'/ST03-D50M': '50 Meter',
	'/ST03-D100M': '100 Meter',
	'/ST03-D200M': '200 Meter',
	'/ST03-D300M': '300 Meter',
	'/ST03-D500M': '500 Meter',
	'/ST03-D1KM': '1 Kilometer',
	'/ST03-D2KM': '2 Kilometer',
	'/ST03-D5KM': '5 Kilometer',
	'/ST03-D10KM': '10 Kilometer',
	'/ST03-D20KM': '20 Kilometer',
	'/ST03-D50KM': '50 Kilometer',
	'/ST03-D100KM': '100 Kilometer',
};

export function getDistanceTypeTranslation(distanceType: number): string {
	const translationKey: string = DISTANCE_TYPES[distanceType];

	if (
		isString(translationKey)
		&& !!(translationKey.length)
		&& DISTANCE_TRANSLATIONS.hasOwnProperty(translationKey)
	) {
		return DISTANCE_TRANSLATIONS[translationKey];
	}

	return DISTANCE_TRANSLATIONS[DISTANCE_TYPES[0]];
}

export const DISTANCE_VALUE_MAPPING: KeyValueObject<number> = {
	'any': 999999999999999,
	'/ST03-D50M': 50,
	'/ST03-D100M': 100,
	'/ST03-D200M': 200,
	'/ST03-D300M': 300,
	'/ST03-D500M': 500,
	'/ST03-D1KM': 1000,
	'/ST03-D2KM': 2000,
	'/ST03-D5KM': 5000,
	'/ST03-D10KM': 10000,
	'/ST03-D20KM': 20000,
	'/ST03-D50KM': 50000,
	'/ST03-D100KM': 100000,
};

export function getDistanceValueToType(distanceType: number): number {
	const id: string = DISTANCE_TYPES[distanceType];

	if (
		isString(id)
		&& !!(id.length)
		&& DISTANCE_VALUE_MAPPING.hasOwnProperty(id)
	) {
		return DISTANCE_VALUE_MAPPING[id];
	}

	return DISTANCE_VALUE_MAPPING[DISTANCE_TYPES[0]];
}

export const DISTANCE_VALUE_INDEX_MAPPING: KeyValueObject<number> = {
	999999999999999: 0,
	50: 1,
	100: 2,
	200: 3,
	300: 4,
	500: 5,
	1000: 6,
	2000: 7,
	5000: 8,
	10000: 9,
	20000: 10,
	50000: 11,
	100000: 12,
};

export function getDistanceIndexToValue(distanceValue: number): number {
	if (DISTANCE_VALUE_INDEX_MAPPING.hasOwnProperty(distanceValue)) {
		return DISTANCE_VALUE_INDEX_MAPPING[distanceValue];
	}

	return 0;
}



// WEBPACK FOOTER //
// ./src/app/xena/core/searchform/advanced-search-dialog/shared/distance.ts